import { apiClient } from "@api/apiClient";

import type {
  PublicationListFilteringData,
  PostPublicationListFilterResponse,
} from "@interface/publicationList.interface";

const API_ENDPOINT = {
  draftArticleList: "/des/publication/list",
  checkPressStatus: "/des/draft-article/status",
};

export const publicationListApis = {
  post: async (filteringData: PublicationListFilteringData) => {
    const { data } = await apiClient.post<PostPublicationListFilterResponse>(
      API_ENDPOINT.draftArticleList,
      filteringData,
    );
    return data;
  },
  checkPressStatus: async (draftArticleId: string) => {
    const { data } = await apiClient.get(
      `${API_ENDPOINT.checkPressStatus}/${draftArticleId}`,
    );
    return data;
  },
};
